export default {
      id: "tax-statements-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tax-statements",
      toString: function () {
        return this.url;
      }
    }